import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 模拟订单数据（用于开发阶段）
const mockOrders = [
  {
    id: 1,
    orderNo: 'ORD20240101001',
    customerName: '张小明',
    customerPhone: '13800138000',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'maternity',
    serviceTypeName: '产康',
    status: 'in_progress',
    statusName: '进行中',
    amount: 12800.00,
    createTime: '2024-01-01 10:00:00',
    startTime: '2024-01-01 10:00:00',
    endTime: '2024-01-15 10:00:00',
    departmentId: 1,
    departmentName: '产康部',
    staffName: '李护士',
    isAbnormal: false,
    isOvertime: false
  },
  {
    id: 2,
    orderNo: 'ORD20240101002',
    customerName: '李小红',
    customerPhone: '13800138001',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'nursing',
    serviceTypeName: '护理',
    status: 'abnormal',
    statusName: '异常订单',
    amount: 15800.00,
    createTime: '2024-01-01 11:00:00',
    startTime: '2024-01-01 11:00:00',
    endTime: '2024-01-20 11:00:00',
    departmentId: 2,
    departmentName: '护理部',
    staffName: '王医生',
    isAbnormal: true,
    isOvertime: false
  },
  {
    id: 3,
    orderNo: 'ORD20240101003',
    customerName: '王小华',
    customerPhone: '13800138002',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'home',
    serviceTypeName: '到家',
    status: 'overtime',
    statusName: '超时订单',
    amount: 8800.00,
    createTime: '2024-01-01 12:00:00',
    startTime: '2024-01-01 12:00:00',
    endTime: '2024-01-10 12:00:00',
    departmentId: 3,
    departmentName: '到家服务部',
    staffName: '张护理师',
    isAbnormal: false,
    isOvertime: true
  },
  {
    id: 4,
    orderNo: 'ORD20240101004',
    customerName: '赵小丽',
    customerPhone: '13800138003',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'maternity',
    serviceTypeName: '产康',
    status: 'pending',
    statusName: '待支付',
    amount: 9800.00,
    createTime: '2024-01-01 13:00:00',
    startTime: null,
    endTime: null,
    departmentId: 1,
    departmentName: '产康部',
    staffName: null,
    isAbnormal: false,
    isOvertime: false
  },
  {
    id: 5,
    orderNo: 'ORD20240101005',
    customerName: '钱小强',
    customerPhone: '13800138004',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'nursing',
    serviceTypeName: '护理',
    status: 'booked',
    statusName: '已预约',
    amount: 16800.00,
    createTime: '2024-01-01 14:00:00',
    startTime: '2024-01-05 10:00:00',
    endTime: '2024-01-25 10:00:00',
    departmentId: 2,
    departmentName: '护理部',
    staffName: '陈护士',
    isAbnormal: false,
    isOvertime: false
  },
  {
    id: 6,
    orderNo: 'ORD20240101006',
    customerName: '孙小美',
    customerPhone: '13800138005',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'home',
    serviceTypeName: '到家',
    status: 'completed',
    statusName: '已完成',
    amount: 6800.00,
    createTime: '2023-12-20 10:00:00',
    startTime: '2023-12-20 10:00:00',
    endTime: '2023-12-30 10:00:00',
    departmentId: 3,
    departmentName: '到家服务部',
    staffName: '刘护理师',
    isAbnormal: false,
    isOvertime: false
  },
  {
    id: 7,
    orderNo: 'ORD20240101007',
    customerName: '周小刚',
    customerPhone: '13800138006',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'maternity',
    serviceTypeName: '产康',
    status: 'normal',
    statusName: '正常订单',
    amount: 11800.00,
    createTime: '2024-01-01 15:00:00',
    startTime: '2024-01-02 10:00:00',
    endTime: '2024-01-16 10:00:00',
    departmentId: 1,
    departmentName: '产康部',
    staffName: '黄护士',
    isAbnormal: false,
    isOvertime: false
  },
  {
    id: 8,
    orderNo: 'ORD20240101008',
    customerName: '吴小芳',
    customerPhone: '13800138007',
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    serviceType: 'nursing',
    serviceTypeName: '护理',
    status: 'in_progress',
    statusName: '进行中',
    amount: 14800.00,
    createTime: '2024-01-01 16:00:00',
    startTime: '2024-01-01 16:00:00',
    endTime: '2024-01-21 16:00:00',
    departmentId: 2,
    departmentName: '护理部',
    staffName: '赵医生',
    isAbnormal: false,
    isOvertime: false
  }
]

// 模拟订单详情数据
const mockOrderDetail = {
  id: 1,
  orderNo: 'ORD20240101001',
  customerName: '张小明',
  customerPhone: '13800138000',
  customerId: 1001,
  customerTags: ['vip', 'old'],
  storeId: 16,
  storeName: '广州市金宝宝月子中心',
  serviceType: 'maternity',
  serviceTypeName: '产康',
  status: 'in_progress',
  statusName: '进行中',
  amount: 12800.00,
  paidAmount: 12800.00,
  createTime: '2024-01-01 10:00:00',
  startTime: '2024-01-01 10:00:00',
  endTime: '2024-01-15 10:00:00',
  departmentId: 1,
  departmentName: '产康部',
  isAbnormal: false,
  isOvertime: false,
  remark: '客户要求特殊服务',
  address: '广州市天河区xxx路xxx号',
  staffName: '李护士',
  staffPhone: '13900139000',
  staffPosition: '高级护理师',
  staffList: [
    { id: 1, name: '李护士', phone: '13900139000', position: '高级护理师', remark: '主要负责产后恢复' },
    { id: 2, name: '王医生', phone: '13800138000', position: '主治医师', remark: '负责乳腺疏通' }
  ],
  services: [
    { id: 1, name: '产后恢复', price: 5000.00, count: 1 },
    { id: 2, name: '乳腺疏通', price: 3000.00, count: 2 },
    { id: 3, name: '盆底修复', price: 4800.00, count: 1 }
  ]
}

/**
 * 获取订单列表
 * @param {Object} query - 查询参数
 * @param {string} query.status - 订单状态（abnormal, normal, overtime, pending, booked, in_progress, completed）
 * @param {string} query.serviceType - 服务类型（maternity, nursing, home，支持多个，用逗号分隔）
 * @param {string} query.storeId - 门店ID
 * @param {string} query.departmentId - 部门ID
 * @param {string} query.startTime - 开始时间
 * @param {string} query.endTime - 结束时间
 * @param {number} query.page - 页码
 * @param {number} query.pageSize - 每页数量
 * @returns {Promise} 返回订单列表数据
 */
export function getOrders(query = {}) {
  // TODO: 对接真实API
  // return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/orders`, { params: query })
  
  // 模拟API响应
  return new Promise((resolve) => {
    setTimeout(() => {
      let filteredOrders = [...mockOrders]
      
      // 根据状态筛选
      if (query.status) {
        if (query.status === 'abnormal') {
          filteredOrders = filteredOrders.filter(order => order.isAbnormal)
        } else if (query.status === 'normal') {
          filteredOrders = filteredOrders.filter(order => order.status === 'normal')
        } else if (query.status === 'overtime') {
          filteredOrders = filteredOrders.filter(order => order.isOvertime)
        } else {
          filteredOrders = filteredOrders.filter(order => order.status === query.status)
        }
      }
      
      // 根据服务类型筛选
      if (query.serviceType) {
        const serviceTypes = query.serviceType.split(',')
        filteredOrders = filteredOrders.filter(order => 
          serviceTypes.includes(order.serviceType)
        )
      }
      
      // 根据门店ID筛选
      if (query.storeId) {
        filteredOrders = filteredOrders.filter(order => 
          String(order.storeId) === String(query.storeId)
        )
      }
      
      // 根据部门ID筛选
      if (query.departmentId) {
        filteredOrders = filteredOrders.filter(order => 
          String(order.departmentId) === String(query.departmentId)
        )
      }
      
      // 分页处理
      const page = query.page || 1
      const pageSize = query.pageSize || 20
      const start = (page - 1) * pageSize
      const end = start + pageSize
      const paginatedOrders = filteredOrders.slice(start, end)
      
      resolve({
        data: {
          list: paginatedOrders,
          total: filteredOrders.length,
          pageNumber: page,
          pageSize: pageSize
        }
      })
    }, 300) // 模拟网络延迟
  })
}

/**
 * 获取订单详情
 * @param {string|number} orderId - 订单ID
 * @returns {Promise} 返回订单详情数据
 */
export function getOrderDetail(orderId) {
  // TODO: 对接真实API
  // return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/orders/${orderId}`)
  
  // 模拟API响应
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          ...mockOrderDetail,
          id: orderId
        }
      })
    }, 200)
  })
}

/**
 * 更新订单状态
 * @param {string|number} orderId - 订单ID
 * @param {Object} data - 更新数据
 * @param {string} data.status - 新状态
 * @returns {Promise} 返回更新结果
 */
export function updateOrderStatus(orderId, data) {
  // TODO: 对接真实API
  // return Api.put(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/orders/${orderId}/status`, data)
  
  // 模拟API响应
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          success: true,
          message: '订单状态更新成功'
        }
      })
    }, 300)
  })
}

/**
 * 处理异常订单
 * @param {string|number} orderId - 订单ID
 * @param {Object} data - 处理数据
 * @returns {Promise} 返回处理结果
 */
export function handleAbnormalOrder(orderId, data) {
  // TODO: 对接真实API
  // return Api.post(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/orders/${orderId}/handle`, data)
  
  // 模拟API响应
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          success: true,
          message: '异常订单处理成功'
        }
      })
    }, 300)
  })
}

// ==================== 派单规则相关API ====================

/**
 * 获取自动派单规则列表
 * @param {Object} query - 查询参数
 * @param {string} query.serviceType - 服务类型（maternity, nursing, home）
 * @param {boolean} query.enabled - 启用状态（true/false）
 * @param {number} query.page - 页码
 * @param {number} query.pageSize - 每页数量
 * @returns {Promise} 返回规则列表数据
 */
export function getDispatchingRules(query = {}) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules`, { params: query })
}

/**
 * 获取自动派单规则详情
 * @param {string|number} ruleId - 规则ID
 * @returns {Promise} 返回规则详情数据
 */
export function getDispatchingRuleDetail(ruleId) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules/${ruleId}`)
}

/**
 * 创建自动派单规则
 * @param {Object} data - 规则数据
 * @returns {Promise} 返回创建结果
 */
export function createDispatchingRule(data) {
  return Api.post(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules`, data)
}

/**
 * 更新自动派单规则
 * @param {string|number} ruleId - 规则ID
 * @param {Object} data - 更新数据
 * @returns {Promise} 返回更新结果
 */
export function updateDispatchingRule(ruleId, data) {
  return Api.put(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules/${ruleId}`, data)
}

/**
 * 删除自动派单规则
 * @param {string|number} ruleId - 规则ID
 * @returns {Promise} 返回删除结果
 */
export function deleteDispatchingRule(ruleId) {
  return Api.delete(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules/${ruleId}`)
}

/**
 * 启用/禁用自动派单规则
 * @param {string|number} ruleId - 规则ID
 * @param {boolean} enabled - 是否启用
 * @returns {Promise} 返回操作结果
 */
export function toggleDispatchingRule(ruleId, enabled) {
  return Api.put(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/rules/${ruleId}/enable`, { enabled })
}

// ==================== 客户管理相关API ====================

/**
 * 获取客户列表
 * @param {Object} query - 查询参数
 * @param {string|string[]} query.tags - 客户标签（VIP、新、旧客）
 * @param {string|number} query.storeId - 门店ID
 * @param {string} query.keyword - 搜索关键词（姓名、手机号）
 * @param {string} query.startTime - 开始时间
 * @param {string} query.endTime - 结束时间
 * @param {number} query.page - 页码
 * @param {number} query.pageSize - 每页数量
 * @returns {Promise} 返回客户列表数据
 */
export function getCustomers(query = {}) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/customers`, { params: query })
}

/**
 * 获取客户详情
 * @param {string|number} customerId - 客户ID
 * @returns {Promise} 返回客户详情数据
 */
export function getCustomerDetail(customerId) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/customers/${customerId}`)
}

/**
 * 创建客户
 * @param {Object} data - 客户数据
 * @param {string} data.name - 客户姓名
 * @param {string} data.phone - 手机号
 * @param {string} data.address - 地址
 * @param {number[]} data.points - 经纬度 [经度, 纬度]
 * @param {string[]} data.tags - 客户标签
 * @param {Object} data.preferences - 客户偏好
 * @returns {Promise} 返回创建结果
 */
export function createCustomer(data) {
  return Api.post(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/customers`, data)
}

/**
 * 更新客户信息
 * @param {string|number} customerId - 客户ID
 * @param {Object} data - 更新数据（支持部分更新）
 * @returns {Promise} 返回更新结果
 */
export function updateCustomer(customerId, data) {
  return Api.put(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/customers/${customerId}`, data)
}

/**
 * 删除客户
 * @param {string|number} customerId - 客户ID
 * @returns {Promise} 返回删除结果
 */
export function deleteCustomer(customerId) {
  return Api.delete(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/customers/${customerId}`)
}

// ==================== 服务通知模板相关API ====================

/**
 * 获取消息模板列表
 * @param {Object} query - 查询参数
 * @param {string} query.templateType - 模板类型筛选（可选）
 * @param {string} query.channel - 通知渠道筛选（可选）"wechat"
 * @param {boolean} query.enabled - 是否启用筛选（可选）
 * @param {number} query.page - 页码（默认1）
 * @param {number} query.pageSize - 每页数量（默认10）
 * @returns {Promise} 返回消息模板列表数据
 */
export function getNotificationTemplates(query = {}) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/notifications/templates`, { params: query })
}

/**
 * 获取消息模板详情
 * @param {string|number} templateId - 模板ID
 * @returns {Promise} 返回消息模板详情数据
 */
export function getNotificationTemplateDetail(templateId) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/notifications/templates/${templateId}`)
}

/**
 * 创建消息模板
 * @param {Object} data - 模板数据
 * @param {string} data.templateName - 模板名称
 * @param {string} data.templateType - 模板类型
 * @param {string} data.title - 通知标题
 * @param {string} data.content - 通知内容
 * @param {string} data.channel - 通知渠道
 * @param {boolean} data.enabled - 是否启用
 * @param {string} data.description - 模板描述（可选）
 * @returns {Promise} 返回创建结果
 */
export function createNotificationTemplate(data) {
  return Api.post(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/notifications/templates`, data)
}

/**
 * 更新消息模板
 * @param {string|number} templateId - 模板ID
 * @param {Object} data - 更新数据（支持部分更新）
 * @returns {Promise} 返回更新结果
 */
export function updateNotificationTemplate(templateId, data) {
  return Api.put(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/notifications/templates/${templateId}`, data)
}

/**
 * 删除消息模板
 * @param {string|number} templateId - 模板ID
 * @returns {Promise} 返回删除结果
 */
export function deleteNotificationTemplate(templateId) {
  return Api.delete(`${BasicConfig.szMysqlDomain}/api/dispatchingJ/notifications/templates/${templateId}`)
}
